import { baseInstance } from './baseInstance';

export const applyAsVendorAPI = (formData) => {
    return baseInstance.post('/Vendor/ApplyAsVendor', formData);
};